module.exports = __webpack_public_path__ + "img/hr-goes-next-gen.0dfec929.jpg";